
export const generator = {
    key: () => {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },
    password: () => {
        const UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
        const NUMBERS = '0123456789';
        const DATE = Date.now().toString();
        const RANDOM_NUMBER = Math.ceil(Math.random() * 100000000).toString();
        const SYMBOLS = '!@#$%^&*()_+-=[]{}|;:,.<>?';

        let password = '';

        const charset = UPPERCASE + LOWERCASE + NUMBERS + SYMBOLS + DATE + RANDOM_NUMBER;
        const remainingLength = length - 4;

        for (let i = 0; i < remainingLength; i++) {
            let randomIndex = Math.floor(Math.random() * charset.length);
            password += charset[randomIndex];
        }
        return password.split('').sort(() => Math.random() - 0.5).join('');
    }
}
